import React from "react";

const FilterTabs = ({ activeFilter, onFilterChange }) => {
  const tabs = [
    { value: "rooms", label: "Liens Demos" },
    { value: "actions", label: "Actions" },
    { value: "rewards", label: "Récompenses" },
  ];

  return (
    <div className="border-b border-gray-200 mb-6">
      <nav className="-mb-px flex space-x-8">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => onFilterChange(tab.value)}
            className={`
              py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors duration-200
              ${activeFilter === tab.value ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"}
            `}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default FilterTabs;
